import { h, Component } from "preact";
import Layout from "../../components/layout/Layout";

import config from "../../config";
import { updateTitle } from "../../utils/BrowserUtils";

import styles from "./404.scss";

class NotFoundPage extends Component {
  checkRedirects() {
    const TICKETING_URL = config("TICKETING_URL");
    const redirectLinks = [
      {
        fromSlug: "banff-mountain-film-festival-canberra-nfsa-3-may-2018",
        toSlug: "payments-test"
      },
      { fromSlug: "come-fly-with-me", toSlug: "come-fly-with-me" },
      {
        fromSlug: "brookies-gin-x-hoc-native-cocktail-degustation",
        toSlug: "brookie-s-gin-x-hoc-native-cocktail-degustation"
      },
      { fromSlug: "homsfightnight", toSlug: "mentalhealthfightnight" },
      {
        fromSlug: "rapid-product-development-prototyping",
        toSlug: "rapid-product-development-and-prototyping"
      },
      {
        fromSlug: "the-road-to-utopiax-starts-with-why",
        toSlug: "the-road-to-utopiax-starts-with-why"
      },
      {
        fromSlug: "whats-your-worth-series-2-creative-industries-lights-out",
        toSlug: "what-s-your-worth-series-2-creative-industries-lights-out"
      },
      {
        fromSlug: "trivia-night-variety-the-childrens-charity",
        toSlug: "trivia-night-supporting-variety-the-children-s-charity"
      },
      {
        fromSlug: "yalari-2018-sydney-dinner",
        toSlug: "yalari-sydney-dinner-2018"
      },
      {
        fromSlug: "yalari-melbourne-dinner-2018",
        toSlug: "yalari-melbourne-dinner-2018"
      },
      {
        fromSlug: "yalari-2018-adelaide-dinner",
        toSlug: "yalari-adelaide-dinner-2018"
      },
      {
        fromSlug: "yalari-2018-brisbane-dinner",
        toSlug: "yalari-brisbane-dinner-2018"
      },
      {
        fromSlug: "stillness-and-sound-reunite",
        toSlug: "stillness-and-sound-reunite"
      },
      {
        fromSlug: "sense-immersion-alternative-speed-dating-sydney",
        toSlug: "sense-immersion-alternative-speed-dating-sydney"
      },
      {
        fromSlug: "food-play-the-delicious-kinky-world-of-sploshing",
        toSlug: "food-play-the-delicious-kinky-world-of-sploshing"
      },
      {
        fromSlug: "sensory-deprivation-melbourne",
        toSlug: "sensory-deprivation-melbourne"
      },
      {
        fromSlug: "food-fighter-transition-film-festival",
        toSlug: "food-fighter-transitions-film-festival"
      },
      {
        fromSlug: "district-9675-rotaract-changeover",
        toSlug: "district-9675-rotaract-changeover"
      },
      {
        fromSlug:
          "order-of-st-john-of-jerusalem-act-commandery-investiture-ceremony",
        toSlug:
          "the-order-of-st-john-of-jerusalem-act-commandery-investiture-ceremony"
      },
      {
        fromSlug: "nonviolent-communication-workshop-2",
        toSlug: "nonviolent-communication-workshop-2"
      },
      {
        fromSlug: "nonviolent-communication-workshops-june-july-2018",
        toSlug: "nonviolent-communication-workshops-june-july-2018"
      },
      {
        fromSlug: "give-me-shelter-fundraising-gala-dinner",
        toSlug: "give-me-shelter-fundraising-gala-dinner"
      },
      {
        fromSlug: "rotary-club-of-wetherill-park-changeover",
        toSlug: "rotary-club-of-wetherill-park-changeover"
      },
      {
        fromSlug: "reconnecting-in-nature-and-flourishing-in-community",
        toSlug: "reconnecting-and-flourishing"
      },
      {
        fromSlug:
          "ems-swiss-dolorclast-academy-rswt-master-course-level-1-special-lower-limb-edition",
        toSlug:
          "ems-dolorclast-sdca-swiss-dolorclast-academy-rswt-master-course-level-1-special-lower-limb-edition-may-23-2018"
      },
      {
        fromSlug:
          "ems-dolorclast-sdca-swiss-dolorclast-academy-rswt-master-course-level-1",
        toSlug:
          "ems-dolorclast-sdca-swiss-dolorclast-academy-rswt-master-course-level-1-may-12"
      },
      {
        fromSlug: "md-solutions-snow-sports-medicine-conference",
        toSlug:
          "md-solutions-snow-sports-medicine-conference-2018-tues-aug-7-to-thurs-aug-9"
      },
      {
        fromSlug: "wild-presented-by-studio-artes-matinee",
        toSlug: "wild-presented-by-studio-artes-matinee"
      },
      {
        fromSlug: "wild-presented-by-studio-artes-evening-performance",
        toSlug: "wild-presented-by-studio-artes-evening-performance"
      },
      { fromSlug: "rhwbvic", toSlug: "red-hot-winter-ball-victoria" },
      {
        fromSlug: "positivitea-high-tea-with-nalini",
        toSlug: "positivitea-high-tea-with-nalini"
      },
      {
        fromSlug: "positivitea-high-tea-with-nalini-5",
        toSlug: "positivitea-high-tea-with-nalini-5"
      },
      {
        fromSlug: "positivitea-high-tea-with-nalini-3",
        toSlug: "positivitea-high-tea-with-nalini-3"
      },
      {
        fromSlug: "positivitea-high-tea-with-nalini-4",
        toSlug: "positivitea-high-tea-with-nalini-4"
      },
      {
        fromSlug: "positivitea-high-tea-with-nalini-2",
        toSlug: "positivitea-high-tea-with-nalini-2"
      },
      {
        fromSlug: "un-wined-an-evening-with-nalini-3",
        toSlug: "un-wined-an-evening-with-nalini"
      },
      {
        fromSlug: "un-wined-an-evening-with-nalini-2",
        toSlug: "un-wined-an-evening-with-nalini-2"
      },
      {
        fromSlug: "cruelty-free-festival-2018",
        toSlug: "cruelty-free-festival-2018"
      },
      {
        fromSlug: "one-world-academy-being-limitless-sydney",
        toSlug: "o-and-o-being-limitless-sydney-2018"
      },
      { fromSlug: "reverence-retreat-2018", toSlug: "reverence-retreat-2018" },
      { fromSlug: "1998-reunion", toSlug: "class-of-1998-reunion" },
      {
        fromSlug: "type-2-diabetes-diabetes-basics-education-session",
        toSlug: "type2-diabetes-diabetes-basics-education-session"
      },
      { fromSlug: "raising-hope-2018", toSlug: "raising-hope-gala-2018" },
      {
        fromSlug: "type-1-diabetes-technology-education-session",
        toSlug: "type1-diabetes-technology-education-session"
      },
      {
        fromSlug: "type-2-diabetes-medications-education-session",
        toSlug: "type2-diabetes-medications-education-session"
      },
      {
        fromSlug: "surry-hills-police-community-gala-ball",
        toSlug: "surry-hills-police-and-community-gala-ball"
      },
      {
        fromSlug: "surry-hills-police-community-gala-ball-corporate-tickets",
        toSlug: "surry-hills-police-and-community-gala-ball-corporate-tickets"
      },
      {
        fromSlug: "type-1-diabetes-exercise-education-session",
        toSlug: "type-1-diabetes-exercise-education-session4"
      },
      {
        fromSlug: "type-2-diabetes-insulin-education-session",
        toSlug: "type2-diabetes-insulin-education-session"
      },
      {
        fromSlug: "type-1-diabetes-carb-counting-education-session",
        toSlug: "type1-diabetes-carb-counting-education-session"
      },
      {
        fromSlug: "type-2-diabetes-annual-cycle-of-care-education-session",
        toSlug: "type2-diabetes-annual-cycle-of-care-education-session"
      },
      {
        fromSlug: "towards-zero-fashioning-the-circular-economy",
        toSlug: "vivid-2018-towards-zero-fashioning-the-circular-economy"
      },
      {
        fromSlug: "acc-community-engagement-conference",
        toSlug: "acc-community-engagement-conference"
      },
      {
        fromSlug: "class-of-98-20-year-reunion-carmel-college",
        toSlug: "class-of-98-20-year-reunion-carmel-college"
      },
      {
        fromSlug: "prism-international-conference-palm-cove-august-2018",
        toSlug: "prism-international-conference-palm-cove-august-2018/"
      },
      {
        fromSlug: "rotaract-district-9810-changeover",
        toSlug: "rotaract-district-9810-changeover"
      },
      {
        fromSlug:
          "prism-international-conference-palm-cove-august-2018-policy-workshop",
        toSlug:
          "prism-international-conference-palm-cove-august-2018-policy-workshop"
      },
      {
        fromSlug: "class-of-2018-graduation-dinner",
        toSlug: "class-of-2018-graduation-dinner"
      },
      {
        fromSlug: "ryla-national-leaders-forum",
        toSlug: "ryla-national-leaders-forum"
      },
      {
        fromSlug: "social-good-summit-2018",
        toSlug: "social-good-summit-australia-2018"
      },
      {
        fromSlug: "soul-events-with-peter-williams-lysa-michel-2",
        toSlug: "soul-events-with-peter-williams-and-lysa-michel"
      },
      {
        fromSlug: "paranormal-weekend-at-wallacia",
        toSlug: "paranormal-weekend-at-wallacia"
      },
      {
        fromSlug: "full-time-lives-transition-program-july-cohort",
        toSlug: "full-time-lives-transition-program-july-cohort"
      },
      {
        fromSlug: "go-for-gold-trivia-night",
        toSlug: "go-for-gold-trivia-night"
      },
      {
        fromSlug: "lomi-lomi-level-1-beginners-sydney-non-residential",
        toSlug: "lomi-lomi-level-1-beginners-sydney-non-residential"
      },
      {
        fromSlug: "conscious-leadership-workshop-23jun18",
        toSlug: "conscious-leadership-workshop"
      },
      {
        fromSlug: "strategic-career-disrupter-june-2018",
        toSlug: "strategic-career-disrupter-june-2018"
      },
      {
        fromSlug: "business-kick-starter-14jun18",
        toSlug: "business-kick-starter"
      },
      {
        fromSlug: "wonderful-me-boost-your-kids-confidence-20jun18",
        toSlug: "wonderful-me-boost-your-kids-confidence-20jun18"
      },
      {
        fromSlug: "central-coast-craft-beer-cider-festival-ccbeerfest18",
        toSlug: "central-coast-craft-beer-and-cider-festival-ccbeerfest18"
      },
      {
        fromSlug: "mornington-peninsula-mens-retreat-iluka",
        toSlug: "mornington-peninsula-men-s-retreat-or-iluka"
      },
      {
        fromSlug: "dance-for-life-18-circus",
        toSlug: "dance-for-life-18-circus"
      },
      {
        fromSlug: "discover-your-mercury-astrology-circle",
        toSlug: "discover-your-mercury-astrology-circle"
      },
      {
        fromSlug: "personal-branding-and-professional-life-2",
        toSlug: "personal-and-professional-branding"
      },
      { fromSlug: "in-frequency", toSlug: "in-frequency" },
      {
        fromSlug: "rotary-club-of-cleveland-business-breakfast",
        toSlug: "rotary-club-of-cleveland-business-breakfast"
      },
      {
        fromSlug: "say-no-to-burnouts-6jun18",
        toSlug: "say-no-to-burnouts-6jun18"
      },
      {
        fromSlug: "womens-hearts-breakfast",
        toSlug: "womens-hearts-breakfast"
      },
      { fromSlug: "introduction-to-qigong", toSlug: "introduction-to-qigong" },
      {
        fromSlug: "mothers-of-boys-annual-lunch-brisbane-2018",
        toSlug: "mothers-of-boys-annual-lunch-brisbane-2018"
      },
      {
        fromSlug: "mothers-of-boys-inaugural-toowoomba-and-beyond-lunch",
        toSlug: "mothers-of-boys-inaugural-toowoomba-and-beyond-lunch"
      },
      { fromSlug: "functional-qi-gong-2", toSlug: "functional-qi-gong" },
      {
        fromSlug: "dynamic-yang-class-5-element-qi-gong",
        toSlug: "dynamic-yang-class-5-element-qi-gong"
      },
      { fromSlug: "functional-qi-gong", toSlug: "functional-qi-gong-IFG99IEJ" },
      {
        fromSlug:
          "speed-mentoring-a-game-for-diverse-professionals-seeking-connections",
        toSlug:
          "speed-mentoring-a-game-for-diverse-professionals-seeking-connections"
      },
      {
        fromSlug: "red-hot-winter-ball",
        toSlug: "red-hot-winter-ball-victoria"
      },
      {
        fromSlug: "the-real-mothers-day-bad-mums-club",
        toSlug: "the-real-mother-s-day-event-bad-mums-club"
      },
      { fromSlug: "red-hot-winter-ball", toSlug: "red-hot-winter-ball" },
      {
        fromSlug: "heart-on-my-sleeve-fight-night-2018",
        toSlug: "mentalhealthfightnight"
      },
      {
        fromSlug: "networking-in-nature-june-7th-botanic-gardens-sydney",
        toSlug: "networking-in-nature-june-7th-botanic-gardens-sydney"
      },
      { fromSlug: "ygap-10-year-birthday", toSlug: "ygap-10-year-birthday" },
      { fromSlug: "makeup", toSlug: "makeup-masterclass-fundraiser" }
    ];
    if (typeof window !== "undefined") {
      let path = window.location.pathname;
      if (path.indexOf("event/") !== -1) {
        let slug = path.replace("/event/", "");
        slug = slug.replace(/\/$/, "");
        const match = redirectLinks.find(
          r => r.fromSlug.toLowerCase() === slug.toLowerCase()
        );
        if (match) {
          window.location = `${TICKETING_URL}/${match.toSlug}`;
        }
        return;
      }
      const pagePath = path.replace(/\/$/, "");
      if (pagePath.split("/").length === 2) {
        window.location = `${TICKETING_URL}${pagePath}`;
      } else {
        this.state.needsRedirect = false;
      }
    }
  }
  constructor() {
    super();
    this.state = {
      needsRedirect: true
    };
    this.checkRedirects = this.checkRedirects.bind(this);
    this.checkRedirects();
  }
  render() {
    const { needsRedirect } = this.state;
    if (needsRedirect) {
      return null;
    }
    return (
      <Layout>
        <div className={styles.wrapper}>
          <div className={styles.content}>
            <h2 className={styles.heading}>404</h2>
            <p className={styles.text}>
              Sorry, this page got lost in the clouds!
            </p>
          </div>
        </div>
      </Layout>
    );
  }
}

export default NotFoundPage;
